// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"19d48782","453":"9db46b06","667":"425722e6","946":"7df26445"}[chunkId] + ".chunk.js";
};